export default __webpack_public_path__ + "static/media/kpi.c3931490.svg";